module.exports = __webpack_public_path__ + "static/media/silfabLogo.a76f34af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-screen/tech-logos/silfabLogo.png
// module id = 500
// module chunks = 0